import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {ResourceTypeColorMap} from '@toolify/client/src/modules/resources/maps/ResourceTypeColorMap'
import {ResourceTypeIconMap} from '@toolify/client/src/modules/resources/maps/ResourceTypeIconMap'
import {ICreateResourceTypeItem} from '@toolify/client/src/modules/resources/composables/useCreateResourceTypeList'
import {i18n} from '@toolify/client/src/setup/i18n'

export interface ITemplateContentTypeOption {
  resourceType: ResourceType
  label: string
  iconNameType: IconNameType
  iconColor: string
}

const LABEL_KEY_BY_RESOURCE_TYPE = new Map<ResourceType, string>([
  [ResourceType.Database, 'importTemplate.contentType.databases'],
  [ResourceType.Conversation, 'importTemplate.contentType.conversations'],
  [ResourceType.CallRoom, 'importTemplate.contentType.calls'],
  [ResourceType.Dashboard, 'importTemplate.contentType.dashboards'],
  [ResourceType.Folder, 'importTemplate.contentType.folders'],
  [ResourceType.Automation, 'importTemplate.contentType.automations'],
  [ResourceType.App, 'importTemplate.contentType.apps'],
  [ResourceType.Document, 'importTemplate.contentType.documents'],
  [ResourceType.Whiteboard, 'importTemplate.contentType.whiteboards'],
  [ResourceType.Skill, 'importTemplate.contentType.skills'],
  [ResourceType.Agent, 'importTemplate.contentType.agents'],
])

export const TEMPLATE_CONTENT_RESOURCE_TYPES = [...LABEL_KEY_BY_RESOURCE_TYPE.keys()].filter(resourceType => {
  return resourceType !== ResourceType.Folder
})

export const getResourceTypePluralLabel = (resourceType: ResourceType): string => {
  const labelKey = LABEL_KEY_BY_RESOURCE_TYPE.get(resourceType)
  return labelKey ? i18n.global.t(labelKey) : resourceType
}

export const getTemplateContentTypeOptions = (
  resourceTypeList: ICreateResourceTypeItem[],
  resourceTypes: ResourceType[] = TEMPLATE_CONTENT_RESOURCE_TYPES,
): ITemplateContentTypeOption[] => {
  const {t} = i18n.global
  return resourceTypes.flatMap(resourceType => {
    const labelKey = LABEL_KEY_BY_RESOURCE_TYPE.get(resourceType)
    if(!labelKey) {
      return []
    }
    const createItem = resourceTypeList.find(item => item.resourceType === resourceType)
    return [{
      resourceType,
      label: t(labelKey),
      iconNameType: createItem?.iconNameType ?? ResourceTypeIconMap.get(resourceType) ?? IconNameType.Grid2,
      iconColor: createItem?.iconBackground ?? ResourceTypeColorMap.get(resourceType) ?? '',
    }]
  })
}
